import { defineStore }  from "pinia";

export const useStore = defineStore('storeId',{
    state:()=>{
        return {
            currWinNums:0,//当前胜场数
            drawFlag:0, //是否领取标记
            sumNum:0,//循环奖励可领取次数
            drawNum:0,//循环奖励已领取的次数
            btnState:true, //按钮开关
        }
    },
    getters:{
        // getDiscountScore(){
        //     return this.discountScore;
        // }
    },
    actions:{
        //设置一个新的值
        setCurrWinNums(val){
            this.currWinNums=parseInt(val);
        },
        setDrawFlag(val){
            this.drawFlag=parseInt(val);
        },
        setSumNum(val){
            this.sumNum=parseInt(val);
        },
        setDrawSumNum(val){
            this.drawNum=parseInt(val);
        },
        //更新drawflag
        updateDrawFlag(val){
            this.drawFlag = this.drawFlag | val
        },
        updateSumNum(){
            this.sumNum--
        },
        updateDrawNum(){
            this.drawNum++
        }

    }
})